import { compose, map, pick, defaultTo } from 'ramda';

import { recordIdentifier } from '@app/helpers/record.helpers';
import { viewBlocks, viewPerson } from '@app/helpers/lenses.helpers';

export const viewIdentifier = compose(
  recordIdentifier,
  viewPerson
);

export const blockLinks = compose(
  map(pick(['blockId', 'title', 'status'])),
  defaultTo([]),
  viewBlocks
);
